module.exports = __webpack_public_path__ + "static/img/dash-arrow.fd3d5ef8.png";